import { useEffect, useState } from 'react'

export type CountdownParts = {
  days: number
  hours: number
  minutes: number
  seconds: number
  done: boolean
}

function compute(target: number): CountdownParts {
  const diff = Math.max(0, target - Date.now())
  return {
    days: Math.floor(diff / 86_400_000),
    hours: Math.floor((diff / 3_600_000) % 24),
    minutes: Math.floor((diff / 60_000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    done: diff === 0,
  }
}

export function useCountdown(targetIso: string): CountdownParts {
  const target = new Date(targetIso).getTime()
  const [parts, setParts] = useState<CountdownParts>(() => compute(target))

  useEffect(() => {
    const id = window.setInterval(() => {
      const next = compute(target)
      setParts(next)
      if (next.done) window.clearInterval(id)
    }, 1000)
    return () => window.clearInterval(id)
  }, [target])

  return parts
}
